import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/images/christmas-sales-banner-mobile.png?url';

export default {
  lqip: `data:image/png;base64,UklGRsQAAABXRUJQVlA4ILgAAABwBACdASogABAAPm0skkWkIqGYBABABsS2AE6ZQAUjb5pkWyNf+ddSgkMQAAD++yctiZWrG02lMMcaprWggfcj/IcaReS+HF+WbNXzXH+SVnOkUUxn30GjgDlu/+LSzP7ROTviziI/LYv0b/9cmBp//QewnP/3BfPSv/4nX7vQB7nuOu1iXhZ+G7+UgyLUZTlKSBtCgN15D487LoavvAckRXSwxeIA+L3e16U4cVRmxWvFi9s5AAAA`,
  src,
  width: 1029,
  height: 525,
};
			